export enum CubemapFormat {
  /** Low dynamic range. */
  ldr = "ldr",
  /** High dynamic range in RGBE8 format. */
  rgbe8 = "rgbe8"
}